import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { useTemplateQueryContext } from 'modules/templateEditor/context/TemplateQueryContext';
import { FC, useState } from 'react';
import { useSaveTemplate } from 'modules/templateEditor/hooks/useSaveTemplate';
import {
  SelectedContentEditorStep,
  SelectContentEditorContextState,
  SelectContentEditorContext,
} from './SelectContentEditorContext';
import { useSelectContentEditor } from '../hooks/useSelectContentEditor';

export const SelectContentEditorProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { setDragAndDropInitValue } = useEditableFieldsContext();

  const { saveTemplateEditor } = useSaveTemplate();

  const { medium } = useTemplateQueryContext();
  const [selectedContentEditorStep, setSelectedContentEditorStep] =
    useState<SelectedContentEditorStep>(SelectedContentEditorStep.SelectEditor);

  const {
    defaultDnDTemplateOptions,
    isLoadingDefaultTemplates,
    refetchDefaultTemplates,
    selectContentEditor,
  } = useSelectContentEditor({
    medium,
    saveTemplateEditor,
    setDragAndDropInitValue,
    setSelectedContentEditorStep,
  });

  const context: SelectContentEditorContextState = {
    dragAndDropTemplateOptions: defaultDnDTemplateOptions,
    getTemplates: refetchDefaultTemplates,
    isLoadingTemplates: isLoadingDefaultTemplates,
    onSelectEditor: selectContentEditor,
    selectedContentEditorStep,
    setSelectedContentEditorStep,
  };

  return (
    <SelectContentEditorContext.Provider value={context}>
      {children}
    </SelectContentEditorContext.Provider>
  );
};
